"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2066],{

/***/ 23891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "PR": function() { return /* binding */ StickyTabsWrapper; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* unused harmony export StyledTab */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var components_common_Tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50557);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}




const StyledTabs = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(components_common_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tabs */ .m)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    & .MuiTabs-indicatorSpan {\n      position: absolute,\n      max-width: 32px;\n      width: 32px !important;\n      border-radius: 2px;\n      background: ".concat(theme.palette.primary.main, ";\n    }\n  ");
});
const StickyTabsWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    position: sticky;\n    top: 0;\n    z-index: 8;\n    background-color: white;\n    margin-bottom: 24px;\n\n    ".concat(theme.breakpoints.up("lg"), " {\n      margin-bottom: 32px;\n    }\n  ");
});
const Tabs = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabs, {
        ...props,
        variant: "scrollable",
        scrollButtons: "auto",
        textColor: "primary",
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "MuiTabs-indicatorSpan"
            }),
            sx: {
                display: "flex",
                justifyContent: "center",
                background: "transparent",
                marginBottom: "4px"
            }
        }
    });
};
const StyledTab = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(components_common_Tabs__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .O)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    &.MuiTab-root {\n      width: auto;\n      font-size: ".concat(theme.typography.subtitle3.fontSize, ";\n      font-weight: 700;\n      padding: ").concat(theme.spacing(0), ";\n      white-space: nowrap;\n      align-items: flex-start;\n\n      &:not(:first-child) {\n        margin-left: 24px;\n      }\n    }\n  ");
});
const Tab = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTab, {
        ...props,
        disableTouchRipple: true
    });
};


/***/ }),

/***/ 50557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62722);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18661);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Tabs = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    .MuiTabScrollButton-root {\n      &.Mui-disabled {\n        opacity: unset;\n        color: ".concat(theme.palette.text.disabled, ";\n      }\n\n      > .MuiSvgIcon-fontSizeSmall {\n        font-size: ").concat(theme.typography.h5.fontSize, ";\n      }\n    }\n\n    .MuiTabs-indicator {\n      height: 4px;\n    }\n  ");
});
const Tab = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    &.MuiTab-root {\n      min-width: unset;\n      padding: ".concat(theme.spacing(3), " ").concat(theme.spacing(4), ";\n      font-size: ").concat(theme.typography.h6.fontSize, ";\n      font-weight: initial;\n\n      &.Mui-selected {\n        font-weight: 700;\n      }\n\n      ").concat(theme.breakpoints.up("lg"), " {\n        padding: ").concat(theme.spacing(3), " ").concat(theme.spacing(6), ";\n      }\n    }\n  ");
});


/***/ }),

/***/ 91886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const MetaTags = (param)=>{
    let { resolvedUrl , articleClassification , article  } = param;
    var _articleClassification_meta, _articleClassification_meta1, _articleClassification_keywords, _article_image;
    const pathName = resolvedUrl.split("?")[0];
    const title = (articleClassification === null || articleClassification === void 0 ? void 0 : (_articleClassification_meta = articleClassification.meta) === null || _articleClassification_meta === void 0 ? void 0 : _articleClassification_meta.title) || (articleClassification === null || articleClassification === void 0 ? void 0 : articleClassification.name);
    const metaTitle = "".concat(title, " - 信義居家");
    const description = articleClassification === null || articleClassification === void 0 ? void 0 : (_articleClassification_meta1 = articleClassification.meta) === null || _articleClassification_meta1 === void 0 ? void 0 : _articleClassification_meta1.describe;
    const keywords = articleClassification === null || articleClassification === void 0 ? void 0 : (_articleClassification_keywords = articleClassification.keywords) === null || _articleClassification_keywords === void 0 ? void 0 : _articleClassification_keywords.map((keyword)=>keyword.name).join(",");
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "首頁",
                item: "https://livinglife.com.tw"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "找好文",
                item: "https://livinglife.com.tw/article"
            },
            {
                "@type": "ListItem",
                position: 3,
                name: articleClassification === null || articleClassification === void 0 ? void 0 : articleClassification.name,
                item: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: "".concat(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName)
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle
            }, "title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }, "keywords"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_APP_DOMAIN */ ._8 + pathName)
            }, "og:url"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: (article === null || article === void 0 ? void 0 : (_article_image = article.image) === null || _article_image === void 0 ? void 0 : _article_image.url) || ""
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbData)
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);


/***/ }),

/***/ 58505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89289);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(79072);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(29630);
/* harmony import */ var _mui_material_Breadcrumbs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(64489);
/* harmony import */ var _mui_icons_material_NavigateNext__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(37958);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(62097);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(61225);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58533);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1216);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(290);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(27961);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(34426);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(92437);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(68138);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(13929);
/* harmony import */ var store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86377);
/* harmony import */ var utils_native_notifier__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(11634);
/* harmony import */ var components_common_Layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82023);
/* harmony import */ var components_common_Header__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75883);
/* harmony import */ var components_common_Footer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56007);
/* harmony import */ var components_common_ContentWrapper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55856);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79592);
/* harmony import */ var components_common_ArticleListItem__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70650);
/* harmony import */ var components_common_InfiniteContainer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26643);
/* harmony import */ var components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2925);
/* harmony import */ var components_common_Present_Tabs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23891);
/* harmony import */ var components_common_LatestArticle__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87624);
/* harmony import */ var components_common_GuessLikesList__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26710);
/* harmony import */ var components_common_Divider__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(20293);
/* harmony import */ var components_common_Hidden__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(18450);
/* harmony import */ var components_common_Banner__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(25820);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
































const a11yProps = (index)=>{
    return {
        id: "scrollable-tab-".concat(index),
        "aria-controls": "scrollable-tab-panel-".concat(index)
    };
};
const CustomLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(components_common_A__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    transition-delay: 0s;\n    transition-duration: .2s;\n    transition-property: color;\n    transition-timing-function: ease;\n\n    &:hover {\n      color: ".concat(theme.palette.primary.main, ";\n    }\n  ");
});
const ClassificationOfArticle = (param)=>{
    let { fallbackData  } = param;
    var _visibleArticleClassifications_tabIndex;
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)();
    const isLarge = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(theme.breakpoints.up("lg"));
    const webview = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(store_webview_webviewSlice__WEBPACK_IMPORTED_MODULE_8__/* .selectWebview */ .hn);
    const [tabIndex, setTabIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.tabIndex) || -1);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.tabIndex)) setTabIndex(fallbackData.tabIndex);
    }, [
        fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.tabIndex
    ]);
    const { data: articleClassifications  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_26__/* .useArticleClassifications */ .$)(null, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articleClassifications
    });
    const visibleArticleClassifications = articleClassifications.filter((item)=>!!item.isVisible);
    const { data , size , setSize  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_27__/* .useInfiniteArticles */ .g)(()=>({
            articleClassificationIds: [
                visibleArticleClassifications[tabIndex]._id
            ]
        }), {
        fallbackData: [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articles
        ]
    });
    const articles = (0,lodash_es__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(data);
    const { data: advertisementBanner  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_29__/* .useBanners */ .U)(webview === null || webview === void 0 ? void 0 : webview.name, {
        displayAt: "articleListAdvertisement"
    });
    const bannerList = (0,lodash_es__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z)(advertisementBanner);
    const onLoadMore = ()=>{
        setSize(size + 1);
    };
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const onTabChange = (event, newTabIndex)=>{
        setTabIndex(newTabIndex);
        const classification = visibleArticleClassifications === null || visibleArticleClassifications === void 0 ? void 0 : visibleArticleClassifications[newTabIndex];
        router.push("/article-classification/".concat(classification.urlId));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const routeChangeCompleteHandler = (url)=>{
            const path = url.split("?")[0];
            const urlIdFromUrl = path.split("/article-classification/")[1];
            const articleClassification = visibleArticleClassifications === null || visibleArticleClassifications === void 0 ? void 0 : visibleArticleClassifications[tabIndex];
            if ((articleClassification === null || articleClassification === void 0 ? void 0 : articleClassification.urlId) !== urlIdFromUrl) {
                const index = visibleArticleClassifications === null || visibleArticleClassifications === void 0 ? void 0 : visibleArticleClassifications.findIndex((classification)=>classification.urlId === urlIdFromUrl);
                if (index > -1) {
                    setTabIndex(index);
                }
            }
        };
        if (router.isReady) {
            router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        }
        return ()=>{
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
        };
    }, [
        router.isReady,
        tabIndex
    ]);
    const containerId = "scrollable-article-classification-container";
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            try {
                (0,utils_native_notifier__WEBPACK_IMPORTED_MODULE_30__/* .enableNativeHeaderMainTabs */ .QL)(false);
                (0,utils_native_notifier__WEBPACK_IMPORTED_MODULE_30__/* .enableNativeHeaderNavBack */ .Gz)(true);
                (0,utils_native_notifier__WEBPACK_IMPORTED_MODULE_30__/* .enableNativeHeaderSearch */ .PP)(true);
            } catch (err) {
                console.error("native notifier error: ", err.message);
            }
        }
    }, [
        webview
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Layout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        stickyHeader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Header__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
        fixContentHeight: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_common_InfiniteContainer__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            id: containerId,
            children: [
                (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && isLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ContentWrapper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    mt: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Breadcrumbs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                        separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_NavigateNext__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                            fontSize: "small"
                        }),
                        "aria-label": "breadcrumb",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomLink, {
                                href: "/",
                                passHref: true,
                                $origin: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        children: "首頁"
                                    })
                                })
                            }, "1"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomLink, {
                                href: "/article",
                                passHref: true,
                                $origin: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        children: "找好文"
                                    })
                                })
                            }, "2"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                variant: "body2",
                                color: "textSecondary",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    children: visibleArticleClassifications === null || visibleArticleClassifications === void 0 ? void 0 : (_visibleArticleClassifications_tabIndex = visibleArticleClassifications[tabIndex]) === null || _visibleArticleClassifications_tabIndex === void 0 ? void 0 : _visibleArticleClassifications_tabIndex.name
                                }, "3")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ContentWrapper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    mt: {
                        xs: 8,
                        lg: 12
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Present_Tabs__WEBPACK_IMPORTED_MODULE_17__/* .Tabs */ .mQ, {
                        value: tabIndex,
                        onChange: onTabChange,
                        variant: "scrollable",
                        indicatorColor: "primary",
                        textColor: "primary",
                        scrollButtons: true,
                        "aria-label": "article classification tabs",
                        children: visibleArticleClassifications === null || visibleArticleClassifications === void 0 ? void 0 : visibleArticleClassifications.map((classification, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Present_Tabs__WEBPACK_IMPORTED_MODULE_17__/* .Tab */ .OK, {
                                label: classification.name,
                                ...a11yProps(index)
                            }, classification._id))
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ContentWrapper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    mt: {
                        xs: 6,
                        lg: 8
                    },
                    mb: 6,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .ZP, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                lg: 8,
                                pr: {
                                    xxl: 12,
                                    maxLimit: 24
                                },
                                px: {
                                    md: 8,
                                    lg: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        dataLength: (articles === null || articles === void 0 ? void 0 : articles.length) || 0,
                                        hasMore: true,
                                        next: onLoadMore,
                                        scrollableTarget: containerId,
                                        scrollThreshold: 0.6,
                                        children: [
                                            articles === null || articles === void 0 ? void 0 : articles.map((article, index)=>{
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                                            height: 350,
                                                            offset: 350,
                                                            scrollContainer: "#".concat(containerId),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                                                        mb: {
                                                                            xs: 8,
                                                                            md: 15
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ArticleListItem__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                            article: article
                                                                        })
                                                                    }),
                                                                    (index + 1) % 10 === 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10) - 1]) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Banner__WEBPACK_IMPORTED_MODULE_22__/* .AdvertisementBanner */ .Nt, {
                                                                        banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10) - 1],
                                                                        bannerLocation: "文章列表頁"
                                                                    }) : "",
                                                                    index === (articles === null || articles === void 0 ? void 0 : articles.length) - 1 && (index + 1) % 10 !== 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10)]) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Banner__WEBPACK_IMPORTED_MODULE_22__/* .AdvertisementBanner */ .Nt, {
                                                                        banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10)],
                                                                        bannerLocation: "文章列表頁"
                                                                    }) : ""
                                                                ]
                                                            }, article._id)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("noscript", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("style", {
                                                                    children: ".lazyload-placeholder { display: none; }"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                                                            mb: {
                                                                                xs: 8,
                                                                                md: 15
                                                                            },
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ArticleListItem__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                                                article: article
                                                                            })
                                                                        }),
                                                                        (index + 1) % 10 === 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10) - 1]) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Banner__WEBPACK_IMPORTED_MODULE_22__/* .AdvertisementBanner */ .Nt, {
                                                                            banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10) - 1],
                                                                            bannerLocation: "文章列表頁"
                                                                        }) : "",
                                                                        index === (articles === null || articles === void 0 ? void 0 : articles.length) - 1 && (index + 1) % 10 !== 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10)]) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Banner__WEBPACK_IMPORTED_MODULE_22__/* .AdvertisementBanner */ .Nt, {
                                                                            banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,lodash_es__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z)((index + 1) / 10)],
                                                                            bannerLocation: "文章列表頁"
                                                                        }) : ""
                                                                    ]
                                                                }, article._id)
                                                            ]
                                                        })
                                                    ]
                                                }, article._id);
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Divider__WEBPACK_IMPORTED_MODULE_20__/* .Solid */ .D, {
                                                mt: {
                                                    xs: 18,
                                                    xl: 24
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Hidden__WEBPACK_IMPORTED_MODULE_21__/* .HideInMobileBox */ .dz, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_LatestArticle__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            mt: 12
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                lg: 4,
                                px: {
                                    md: 8,
                                    lg: 0
                                },
                                pl: {
                                    lg: 20,
                                    xl: 24,
                                    xxl: 38,
                                    maxLimit: 41
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_GuessLikesList__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        articleClassification: visibleArticleClassifications[tabIndex],
                                        mt: {
                                            xs: 12,
                                            lg: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Hidden__WEBPACK_IMPORTED_MODULE_21__/* .HideInDesktopBox */ .aI, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_LatestArticle__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            mt: 12
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Footer__WEBPACK_IMPORTED_MODULE_11__["default"], {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClassificationOfArticle);


/***/ })

}]);